// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__31mha","title":"FrontImage_title__MSeZ8"};